#import "../fragments/queued-email-fragment.graphql"

query GetSendingEmails($limit: Int!, $cursor: String) {
    sendingEmails(first: $limit, after: $cursor) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            cursor
            node {
                ...QueuedEmail
            }
        }
    }
}
